import { AppBar, Box, Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Stack, Toolbar, Typography, useColorScheme } from "@mui/material";
import { useState } from "react";
import MenuIcon from '@mui/icons-material/Menu';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { Constants } from "../../utils/constants";
import LogoWidget from "../widgets/logo_widget";

const drawerWidth = `calc(${Constants.Styles.spacing} * 64)`;

export default function MainHeader(props) {

  const { window, children, menus, onOpenChange, activeMenu } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const { mode, setMode } = useColorScheme();
  const currentMode = mode || 'light';

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleLightDarkMode = () => {
    const newMode = mode === 'light' ? 'dark' : 'light';
    setMode(newMode);
    localStorage.setItem("mode", newMode);
  }

  const drawerItem = ({ icon, title, key, onClick, isActive }) => {
    if (!mode) {
      return null;
    }
    return <Box key={key}>
      <Box
        sx={{
          cursor: "pointer",
          borderRadius: `calc(${Constants.Styles.radius.base} - 2px)`,
          bgcolor: isActive ? Constants.Colors[mode].sidebarAccent : "inherit",
          display: "flex",
          alignItems: "center",
          paddingInline: "calc(0.25rem * 3)",
          paddingBlock: "calc(0.25rem * 2)",
          color: isActive ? Constants.Colors[mode].sidebarPrimary : Constants.Colors[mode].mutedForeground,
          "&:hover": {
            bgcolor: Constants.Colors[mode].sidebarAccent,
          }
        }}
        onClick={onClick}
      >
        {icon}
        <Typography sx={{ ml: "8px", fontSize: Constants.Styles.fontSize.sm, fontWeight: Constants.Styles.fontWeight.medium, lineHeight: "calc(1.5 / 0.875)" }}>{title}</Typography>
      </Box>
    </Box>;
  }

  const drawer = (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Toolbar>
        <LogoWidget />
      </Toolbar>
      <Divider />
      <List sx={{ flexGrow: 1, padding: "1rem 0.75rem", margin: 0, }}>
        {menus.map((item, index) => (
          drawerItem({
            icon: item.icon,
            title: item.title,
            key: item.key,
            onClick: () => onOpenChange(item.key),
            isActive: activeMenu === item.key,
          })
        ))}
      </List>


      <Divider />
      <List>
        {drawerItem({
          icon: <LogoutOutlinedIcon />,
          title: "Logout",
          key: "logout",
          onClick: () => onOpenChange("logout"),
          isActive: false,
        })}
      </List>
    </Box>
  );

  // Remove this const when copying and pasting into your project.
  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box>
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth})` },
          ml: { sm: `${drawerWidth}` },
          bgcolor: 'background.default',
          borderBottom: mode ? `1px solid ${Constants.Colors[mode].border}` : "none",
          backgroundImage: "none",
        }}
        style={{
          "--Paper-shadow": "none",
          "--AppBar-background": "none",
          "--AppBar-color": "none",

        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Stack
            direction="row"
            spacing={0.3}
            sx={{
              ml: "auto",
            }}
          >
            <IconButton
              edge="start"
              onClick={handleLightDarkMode}
            >
              {mode === 'light' ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
            </IconButton>
            <IconButton
              edge="start"
              onClick={handleDrawerToggle}
            >
              <NotificationsNoneOutlinedIcon />
            </IconButton>
            <IconButton
              edge="start"
              onClick={handleDrawerToggle}
            >
              <PermIdentityOutlinedIcon />
            </IconButton>
          </Stack>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: `${drawerWidth}` }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: `${drawerWidth}` },
          }}
          slotProps={{
            root: {
              keepMounted: true, // Better open performance on mobile.
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: `${drawerWidth}` },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        // component="main"
        sx={{ 
          flexGrow: 1, 
          p: { xs: "1rem", sm: "1rem", md: "1.5rem" },
        }}
        ml={{ sm: `${drawerWidth}` }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
}